const HomePurchaseText ={textTable: [
    {textType: "notEnoughCash", errorType: "critical", 
        text: "You do not currently have enough cash in the bank to cover " +
        "the one-time costs for this home.  You need to make a different home choice."
    },
    {textType: "notEnoughCashDownPayment", errorType: "critical", 
        text: "The down payment amount is greater than the amount that you have in the bank " +
        "(including savings).  You need to make a different home choice or reduce the " +
        "down payment amount."
    },
    {textType: "transferCashLit1", errorType: "critical", 
        text:  "You do not currently have enough cash in the bank to cover " +
        "the one-time costs for this home.  " +
        "You need to reduce the amount of the down payment ...OR... make a different "  +
        "home choice."
    },
    {textType: "transferCashLit2", errorType: "critical", 
        text: "...OR...  transfer money from your savings account to your " +
        "bank account.  To transfer money, close this pop-up.  Then " +
        "click on the Unlocked Features button, click on the setup or change Savings " +
        "Button and enter the amount you wish to transfer. " +
        "Remember to transfer more than the amount you need to cover " +
        "the transfer fee and to leave enough cash in the bank for unexpected expenses."
    },
    {textType: "loanNotApprovedIncome", errorType: "critical", 
        text: "Your home loan has not been approved.  The lender has determined " +
        "that your monthly income is not enough to cover the expenses of the new home.  You " +
        "can reduce the mortgage by increasing the amount of your down payment, " + 
        "select 1 or more roommates, ....OR...." +
        "select another home that is not so expensive."
    },
     {textType: "loanNotApprovedCreditScore", errorType: "critical", 
        text: "Your home loan has not been approved.  The lender has determined " +
        "that your credit score is too low.  Your current score is ||creditScore||. "+ 
        "Your score must be greater than 620 to qualify for a mortgage."
    },
    {textType: "monthlyIncomeError", errorType: "critical", 
        text: "Your monthly income is not large enough to cover the monthly costs " +
        "with the selected number of roommates. If you still wish to choose this home, " +
        "you can go back and add 1 or more roommates to assist with the monthly costs."
    },
    {textType: "monthlyIncomeErrorOK", errorType: "warning", 
        text: "Your monthly income is not large enough to cover the monthly costs " +
        "with the selected number of roommates but you can still make this change " +
        "if you wish.",
},
]
}
    
export default HomePurchaseText;